"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const RewardsGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "REWARDS-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.862 3.53a.5.5 0 0 1 .342.94l-1.88.684a.5.5 0 0 1-.342-.94ZM20.607.88a.5.5 0 0 1 .848.53l-1.06 1.696a.5.5 0 1 1-.848-.53Zm-3.09-.854.09-.011a.5.5 0 0 1 .516.482l.07 1.999a.5.5 0 1 1-1 .035l-.07-2a.5.5 0 0 1 .483-.516Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M17.93 4.116c.324 0 .637.078.917.221l-.056-.023c.031.01.06.025.088.04.255.137.482.329.66.566l3.36 4.484a2.01 2.01 0 0 1-.064 2.492L13.427 23.28a2.01 2.01 0 0 1-1.541.72l.065-.002a.497.497 0 0 1-.059.004h-.01l-.04-.002a2.01 2.01 0 0 1-1.5-.723L.937 11.898a2.007 2.007 0 0 1-.461-1.153.54.54 0 0 1-.007-.085l.002-.028c-.004-.43.13-.863.402-1.227L4.234 4.92a2.01 2.01 0 0 1 1.61-.804ZM6.913 11.159h-5.28l.074.1 9.286 11.238-4.08-11.338m15.225 0h-5.279L12.782 22.49l9.284-11.233c.026-.031.05-.064.072-.098m-6.342 0H7.975l3.911 10.866 3.91-10.866M4.932 5.656l-3.259 4.347c-.037.05-.069.102-.096.156h4.976L4.932 5.656Zm13.907-.001-1.62 4.504h4.975a1.009 1.009 0 0 0-.027-.05l-.07-.106-3.258-4.348m-6.953-.207L8.353 10.16h7.066l-3.533-4.71m-1.001-.332H5.801L7.45 9.699l3.436-4.582m7.045 0h-5.043l3.435 4.581 1.648-4.579-.04-.002"
  })));
};
RewardsGraphicIcon.displayName = "RewardsGraphicIcon";
RewardsGraphicIcon.iconName = "Rewards";
export default RewardsGraphicIcon;